export default __webpack_public_path__ + "static/media/InsideKidneys_08.2708654f.png";